import { render, staticRenderFns } from "./ly-index.vue?vue&type=template&id=ed9510fc&scoped=true"
import script from "./ly-index.vue?vue&type=script&lang=js"
export * from "./ly-index.vue?vue&type=script&lang=js"
import style0 from "./ly-index.vue?vue&type=style&index=0&id=ed9510fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9510fc",
  null
  
)

export default component.exports